/**
* description:
* File of container LoginSubscriberNumberForm Component (Dumb)
*
* data : 2017-08-03
*/

import { mapActions } from 'vuex';
import sNumberValidation from '@/services/sNumberValidation';

// CHILD COMPONENTS ////////////////////////////////////////////////////////////
import SmallLoadingSpinner from '@/components/Common/SmallLoadingSpinner';
import LoginErrorMessage from '@/components/Login/LoginErrorMessage';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'LoginSubscriberNumberForm',

  components: {
    LoginErrorMessage, SmallLoadingSpinner,
  },

  props: ['loginCredentialsIncorrect', 'loginLoadingActive'],

  data() {
    return {
      subscriberNumber: null,
    };
  },

  beforeMount() {
    this.resetNumber();
  },

  methods: {
    ...mapActions(['checkNumber']),
    submitSubscriberNumber() {
      const subscriberNumber = this.subscriberNumber;
      this.checkNumber({ subscriberNumber });
    },
    validatePhoneNumber() {
      const number = sNumberValidation.validateNumber(this.subscriberNumber);
      this.subscriberNumber = number;
    },
    resetNumber() {
      this.subscriberNumber = null;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Login/LoginSubscriberNumberForm/component.js